import {
  Button,
  Divider,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { GRAY } from "../../../../constants/colors";
import {
  dateForList,
  dateForListWithHours,
} from "../../../../constants/dataFormat";
import {
  CNPJFormater,
  CPFFormater,
  ToLocaleFormat,
} from "../../../../defaultFunctions/formaters";
import InfoCardsDetalhamento from "../defaultComponents/InfoCardsDetalhamento";

export default function ModalDetail({
  isOpen,
  setIsOpen,
  item,
}: any) {
  const finalRef = React.useRef(null);

  const onClose = () => {
    setIsOpen(false);
  };

  const [objetoPagamento, setObjetoPagamento] = useState<any>();
  // const [objetoSolicitante, setObjetoSolicitante] = useState<any>();
  const [objetoBeneficiario, setObjetoBeneficiario] = useState<any>();

  useEffect(() => {
    if (item && Object.keys(item).length !== 0) {
      const gerarObjetoPagamento = () => {
        return [
          {
            titulo: "Código de Barras: ",
            valor: item && item.codigoBarras,
          },
          {
            titulo: "Data da Criação: ",
            valor: item && moment(item.criadoEm).format(dateForListWithHours),
          },
          {
            titulo: "Data do Vencimento: ",
            valor: item && moment(item.vencimento).format(dateForList),
          },
          {
            titulo: "Descontos: ",
            valor: item && ToLocaleFormat(item.descontos),
          },
          {
            titulo: "Juros: ",
            valor: item && ToLocaleFormat(item.juros),
          },
          {
            titulo: "Valor Nominal: ",
            valor: item && ToLocaleFormat(item.valorNominal),
          },
          {
            titulo: "Valor Pagamento: ",
            valor: item && ToLocaleFormat(item.valorPagamento),
          },
          {
            titulo: "Observação: ",
            valor: item && item.observacao,
          },
        ];
      };
      // const gerarObjetoSolicitante = () => {
      //   return [
      //     {
      //       titulo: "Nome do Solicitante: ",
      //       valor:
      //         item && item?.cliente?.isCnpj === true
      //           ? `${item?.cliente?.razaoSocial}`
      //           : `${item.cliente.nome} ${item.cliente.sobrenome}`,
      //     },
      //     {
      //       titulo: "CPF/CNPJ do Solicitante: ",
      //       valor:
      //         item && item.cliente.isCnpj === true
      //           ? CNPJFormater(item.cliente.cnpj)
      //           : CPFFormater(item.cliente.cnpj),
      //     },
      //   ];
      // };
      const gerarObjetoBeneficiario = () => {
        return [
          {
            titulo: "Nome do Beneficiário: ",
            valor: item.nomeBeneficiario,
          },
          {
            titulo: "CPF/CNPJ do Beneficiário: ",
            valor:
              item && item.cnpjBeneficiario.length === 11
                ? CPFFormater(item.cnpjBeneficiario)
                : CNPJFormater(item.cnpjBeneficiario),
          },
        ];
      };
      // setObjetoSolicitante(gerarObjetoSolicitante());
      setObjetoBeneficiario(gerarObjetoBeneficiario());
      setObjetoPagamento(gerarObjetoPagamento());
    }
  }, [item]);

  console.log("item", item)

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"4xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"}>
              <Text fontWeight={"bold"}>
                Detalhamento da Solicitação de Pagamento
              </Text>
            </Flex>
          </ModalHeader>
          {item ? (
            <ModalBody
              display={"flex"}
              justifyContent={"center"}
            >
              <Flex
                w={"85%"}
                alignItems={"flex-start"}
                minHeight={"250px"}
                height={"fit-content"}
                border={"2px solid #c4c4c4"}
                flexDir={"column"}
                shadow={"md"}
                borderRadius={"6px"}
                px={4}
                py={4}
              >
                <InfoCardsDetalhamento
                  title={"Informações da Solicitação de Pagamento"}
                  array={objetoPagamento}
                />
                <Divider variant="dashed"></Divider>
                <InfoCardsDetalhamento
                  title={"Informações do Beneficiário"}
                  array={objetoBeneficiario}
                />
              </Flex>
            </ModalBody>
          ) : (
            <></>
          )} 
          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={GRAY} color={"white"} mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
